<template>
    <div class="col_item" :style="styleString"
         @mousedown.left.prevent="action_MouseDown"
         @mousemove.left.prevent="action_MouseMove"
         @mouseup.left.prevent="action_MouseUp"
    >
        {{ timeString }}
        <!-- 높이 늘리기 -->
        <div class="row_resize"
             @mousedown.left.prevent="action_HeightMouseDown"
        ></div>
    </div>
</template>


<script>
import { closeHServiceSearch, hideCellMenu, hideReservationMenu } from '../../../sheet-overlays'
import { sheetAxis } from '../../../sheet-axis'
import { sheetFilters } from '../../../sheet-filters'
import { timeHeight, startTimeResize } from './time-height'

export default {
    props: {
        timeData: Object,
        selectedAreaHelper: Object,
    },
    data() {
        return {
            sheetAxis,
            sheetFilters,
            timeHeight
        }
    },
    computed: {
        timeString: function () {
            return this.timeData.timeString
        },
        yPosition: function () {
            return this.timeData.index
        },
        selectedColumnCount: function () {
            let usableGroups = this.sheetFilters.usableGroups
            let count = 0
            usableGroups.forEach(g => {
                count += g.columns?.length ?? 0
            })
            return count
        },
        timeArray: function () {
            return this.sheetAxis.timeArray
        },
        height: function () {
            return this.timeData.height
        },
        styleString: function () {
            return 'flex-basis: unset; height: ' + this.height + 'px;'
        },
        selectedRange: function () {
            return this.selectedAreaHelper.selectedRange
        },
        startY: function () {
            return this.selectedRange.start.y > this.selectedRange.end.y ? this.selectedRange.end.y : this.selectedRange.start.y
        },
        endY: function () {
            return this.selectedRange.end.y
        }
    },
    methods: {
        action_MouseDown() {
            if (this.timeHeight.isResizing == true) { return }
            closeHServiceSearch()
            hideCellMenu()
            hideReservationMenu()
            this.selectedAreaHelper.setType(this.selectedAreaHelper.Type.time)
            this.selectedAreaHelper.setStartPoint(0, this.yPosition)
        },
        action_MouseMove() {
            if (this.timeHeight.isResizing == true) { return }
            if (this.selectedAreaHelper == undefined) { return }
            if (this.selectedAreaHelper.startPoint.x == undefined) { return }
            if (this.selectedAreaHelper.currentType != this.selectedAreaHelper.Type.time) { return }
            this.selectedAreaHelper.setEndPoint(this.selectedColumnCount - 1, this.yPosition)
            let start = this.selectedAreaHelper.endPoint
            let end = this.selectedAreaHelper.startPoint
            this.selectedAreaHelper.setSelectedRange(start.x, start.y, end.x, end.y)
        },
        action_MouseUp() {
            if (this.timeHeight.isResizing == true) { return }
            if (this.selectedAreaHelper.currentType != this.selectedAreaHelper.Type.time) { return }
            this.selectedAreaHelper.setEndPoint(this.selectedColumnCount - 1, this.yPosition)
            let start = this.selectedAreaHelper.endPoint
            let end = this.selectedAreaHelper.startPoint
            this.selectedAreaHelper.setSelectedRange(start.x, end.y, end.x, start.y)
            this.selectedAreaHelper.clearStartEndPoint()
        },

        action_HeightMouseDown(e) {
            e.stopPropagation()
            if (this.startY > this.yPosition || this.endY < this.yPosition) { this.selectedAreaHelper.clearSelectedRange() }
            startTimeResize(e, this.timeData.timeString, { areaHelper: this.selectedAreaHelper })
        },
    }
}
</script>